import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Header.css'
import Cookies from 'js-cookie';
import { FetchNotificationData, getdata, setActivity } from '../../Global/Index';
import { useTheme } from "@mui/material";
import { setMode } from '../../Store/Store';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { useQueryClient } from '@tanstack/react-query';

const apiurl = process.env.REACT_APP_API_URL;


const Notification = ({ mobileNumber }) => {
  const [showAll, setShowAll] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const ref = React.createRef();
  const [events, setEvents] = useState([]);
  const [countofread, setCountofread] = useState(0)
  const theme = useTheme();


  const SetNotifications = React.useCallback(async () => {
    try {
      const data1 = await FetchNotificationData(mobileNumber); // Assuming the data is directly in response.data
      if (data1.response.status === "200") {
        const data = data1.detailList || [];
        const formattedEvents = data.map((item, index) => {
          // Extracting the date from createdDate and formatting it
          const createdDate = new Date(item.createdDate);
          const formattedDate = `${createdDate.getUTCFullYear()}-${String(createdDate.getUTCMonth() + 1).padStart(2, '0')}-${String(createdDate.getUTCDate()).padStart(2, '0')}`;

          return {
            value: item.value || index.toString(),
            title: item.title || 'No title available',
            IsRead: item.IsRead || 'No isread available',
            id: item.id || 'No id available',
            message: item.message || 'No message available',
            createdDate: formattedDate // Use the formatted date here
          };
        });

        setEvents(formattedEvents);

      } else if (data1.response.status === "419") {
        window.location.href = '/Session-Expired'
      } else if (data1.response.status === '401') {
        window.location.href = '/'
      }
    } catch (error) {
      console.error('Error fetching notifications:', error);
    }
  }, [mobileNumber]);

  const Updatecountofread = () => {
    let count = 0;

    if (events.length > 0) {
      events.forEach(event => {
        if (event.IsRead == "UnRead" || event.IsRead == false || event.IsRead == 'unread' || event.IsRead == 'unRead') {
          count++;
        }
      });
    }

    setCountofread(count);
  };



  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };


  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [ref]);

  useEffect(() => {
    SetNotifications(); // Fetch notifications when the component mounts
  }, [SetNotifications]);


  useEffect(() => {
    Updatecountofread(); // Fetch notifications when the component mounts
  });



  const handleToggle = async () => {
    setIsOpen(!isOpen);

  };




  return (
    <div ref={ref}>
      <button
        className="notification-icon"
        onClick={handleToggle}
        aria-label="Toggle notifications"
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: theme.palette.primary.main }}
      >
        <i className="bi bi-bell" />
        {countofread > 0 && <span className="badge">{countofread}</span>}
      </button>

      {isOpen && events.length > 0 ? (
        <div className="dropdown-menu1" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main, display: 'flex', gap: '.51vw', height: '60vh', overflowY: 'auto' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '17px', borderBottom: '1px solid lightgray', padding: '2vh 3vh' }}>
            <span>Notification</span>
            <span style={{ padding: '0vw 3vh', color: 'white', backgroundColor: 'rgb(155,17,94)', borderRadius: '20vh', fontSize: '16px' }}>{events.length}</span>
          </div>

          {events.slice(0, showAll ? events.length : 5).map((event, index) => (
            <div key={index + 1} className="dropdown-item" style={{ width: '100%', fontSize: '.7vw', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexDirection: 'column', gap: '.51vw', backgroundColor: 'white', color: event.IsRead === "UnRead" ? "gray" : "black", padding: '1vw' }}>
              <div className="notificationcontainer">
                <p>{event.title}</p>
                <p>{event.createdDate}</p>
              </div>
              <div className="notificationsubcontainer">
                <p>{event.message}</p>
                {event.IsRead === "Read" && <div className='blinking-circle'></div>}
              </div>
            </div>
          ))}

          {events.length > 5 && (
            <button className='eventsubmit' onClick={() => setShowAll(!showAll)}>
              {showAll ? 'See Less' : 'Show all notifications'}
            </button>
          )}
        </div>
      ) : null}

      {/* Extracted independent statement for "No new notifications found" */}
      {isOpen && events.length === 0 && (
        <div className="dropdown-menu1" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main, fontSize: '15px', textAlign: 'center', padding: '1vh' }}>
          No new notifications found
        </div>
      )}
    </div>
  );

}


const Userloginlogout = () => {
  const [isOpen, setIsOpen] = useState(false);
  const ref = React.createRef();
  const navigate = useNavigate();
  const theme = useTheme();
  // Get the queryClient instance that was provided in index.js
  const queryClient = useQueryClient();

  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  const logout = async () => {
    setActivity('User Logged Out')
    queryClient.removeQueries();
    const response = await axios.post(`${apiurl}/Logout`, {}, { withCredentials: true });
    if (response?.data?.status == '200') {
      toast.success(response?.data?.message);
      navigate('/')
    } else if ((response?.data?.status == '401')) {
      navigate('/')
    } else {
      toast.error('Something went wrong. Please try again later!')
    }

  }


  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [ref]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };



  return (
    <div ref={ref}>
      {isOpen && (
        <div className="dropdown-menu" style={{ backgroundColor: theme.palette.background.alt }}>
          <Link
            to="Personal-Info"
            className="dropdown-item"
            style={{ color: theme.palette.primary.main, textDecoration: 'none' }}
            onClick={() => {
              localStorage.setItem('activeLinkId', '0');
              localStorage.setItem('dropedownid', JSON.stringify([]));
            }}
          >
            <i className="bi bi-person"></i> View Profile
          </Link>
          <Link to="#" className="dropdown-item" onClick={logout} style={{ color: theme.palette.primary.main, textDecoration: 'none' }}>
            <i className="bi bi-box-arrow-right"></i> Logout
          </Link>

        </div>
      )}

      <button
        className="profile-icon"
        onClick={handleToggle}
        aria-label="Toggle notifications"
        style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: theme.palette.primary.main }}
      >
        <i className="bi bi-person-gear" style={{ fontSize: '23px' }} />
      </button>

    </div>
  );
};



const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const encoded_token = Cookies.get('token');
  const [mobileNumber, setMobileNumber] = useState(null);

  useEffect(() => {
    const gettingData = async () => {
      const data = await getdata();
      if (data.response.status == '200') {
        setMobileNumber(data.response.data.MobileNumber);
      }
    }
    gettingData();
  }, [])



  if (!encoded_token) {
    window.location.href = process.env.REACT_APP_FRONTEND_URL;
  }

  return (

    <div className="header" style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
      <div className="headermaincontainer">
        <div className="menu-icon">
          <button
            className="profile-icon"
            onClick={toggleSidebar}
            aria-label="Toggle notifications"
            style={{ background: 'none', border: 'none', padding: 0, cursor: 'pointer', color: theme.palette.primary.main }}
          >
            <i className="bi bi-list" style={{ fontSize: '27px' }}></i>
          </button>
        </div>
        <div style={{ display: 'flex', gap: '1vw', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
          {/* Dark/Light Mode Toggle */}
          <div style={{ color: theme.palette.primary[100] }}>
            <button onClick={() => dispatch(setMode())} title="Dark Mode" style={{ cursor: 'pointer', alignContent: 'center', border: 'none', backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }} className='mode'>
              {theme.palette.mode === "dark" ? (
                <i className="bi bi-moon-fill" title="Switch to Light Mode" ></i>
              ) : (
                <i className="bi bi-brightness-high-fill" title="Switch to Dark Mode"></i>
              )}
            </button>
          </div>
          {/* <div onClick={changetheme} style={{ alignContent: 'center' }}>{currenttheme == "light" ? <i className="bi bi-moon" id='halfmoon' /> : <i class="bi bi-brightness-high-fill" id='fullmoon' />}</div> */}
          {/* <div id='language'><i className="bi bi-translate"></i></div> */}{
            mobileNumber && <div id='notification' style={{ color: theme.palette.primary[100] }}> <Notification mobileNumber={mobileNumber} /></div>
          }
          <div id='useloginlogout' style={{ color: theme.palette.primary[100] }}> <Userloginlogout /></div>
        </div>
      </div>
    </div>
  )
}

// PropTypes validation

Notification.propTypes = {
  mobileNumber: PropTypes.string.isRequired,
};

Header.propTypes = {
  toggleSidebar: PropTypes.func.isRequired
};

export default Header;

